import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpService } from 'src/app/http.service';
import { GlobalService } from 'src/app/global.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';

@Component({
  selector: 'app-super-sale-group-product',
  templateUrl: './super-sale-group-product.component.html',
  styleUrls: ['./super-sale-group-product.component.scss']
})
export class SuperSaleGroupProductComponent implements OnInit {
  is_data_available = false;
  product_data: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';

  constructor(public dialogRef: MatDialogRef<SuperSaleGroupProductComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private http: HttpService, private global: GlobalService) {
    console.log(data);
    this.is_data_available = true;
    let data_dict = {
      'from_date': data['from_date'],
      'to_date': data['to_date'],
      'selected_business_code': data['business_code']
    };
    this.http.serveSuperSaleGroupForProduct(data_dict).subscribe((data) => {
      console.log(data);
      this.product_data = data;
      this.is_data_available = false;
    }, (error) => {
      this.is_data_available = false;
      console.error(error);
    });
  }

  closeClicked() {
    this.dialogRef.close();
  }

  ngOnInit() {
  }

}
